import { render, staticRenderFns } from "./TableEquipment.vue?vue&type=template&id=5089ffde&scoped=true"
import script from "./TableEquipment.vue?vue&type=script&lang=js"
export * from "./TableEquipment.vue?vue&type=script&lang=js"
import style0 from "./TableEquipment.vue?vue&type=style&index=0&id=5089ffde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5089ffde",
  null
  
)

export default component.exports